module.exports = __webpack_public_path__ + "static/img/dialog.b27f508.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dialog.png
// module id = 559
// module chunks = 143